import { render, staticRenderFns } from "./FilterButton.vue?vue&type=template&id=be4229b2&scoped=true&"
import script from "./FilterButton.vue?vue&type=script&lang=js&"
export * from "./FilterButton.vue?vue&type=script&lang=js&"
import style0 from "./FilterButton.vue?vue&type=style&index=0&id=be4229b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4229b2",
  null
  
)

export default component.exports